import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import UserService from 'api/services/UserService';
import { RootState } from 'store/store';

export const fetchMe = createAsyncThunk('fetchMe', async () => {
    const response = await UserService.me();
    return response.data;
});

export const fetchUsers = createAsyncThunk('fetchUsers', async () => {
    const response = await UserService.users();
    return response.data;
});

export const fetchUserById = createAsyncThunk('fetchUserById', async (id: string) => {
    const response = await UserService.userById(id);
    return response.data;
});

export const fetchUpdatePassword = createAsyncThunk('fetchUpdatePassword', async (params: any) => {
    const response = await UserService.updatePassword(params);
    return response.data;
});

type TUserState = {
    me: {
        data: {
            id: string;
            email: string;
            status: string;
            globalRole: string;
            firstName: string;
            lastName: string;
            company: {
                id: string;
                name: string;
            };
            role: {
                id: string;
                name: string;
                type: string;
                companyId: string;
            };
        };
        isLoading: boolean;
    };
    users: {
        data:
            | {}
            | {
                  id: string;
                  name: string;
                  email: string;
                  status: string;
                  globalRole: string;
                  company: {
                      id: string;
                      name: string;
                  };
                  roles: Array<{
                      type: string;
                      id: string;
                      name: string;
                      companyId: string;
                  }>;
              };
        isLoading: boolean;
    };
};

const initialState: TUserState = {
    me: {
        data: null as any,
        isLoading: false,
    },
    users: {
        data: {},
        isLoading: false,
    },
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchMe.pending, state => {
                state.me.isLoading = true;
            })
            .addCase(fetchMe.fulfilled, (state, action) => {
                state.me.data = action.payload;
                state.me.isLoading = false;
            });
        builder
            .addCase(fetchUsers.pending, state => {
                state.users.isLoading = true;
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.users.data = action.payload;
                state.users.isLoading = false;
            });
    },
});

export const selectMe = createSelector([(state: RootState) => state.userState.me], me => me.data);
export const selectMeIsLoading = createSelector([(state: RootState) => state.userState.me], me => me.isLoading);

export const selectUsers = createSelector([(state: RootState) => state.userState.users], users => users.data);
export const selectUsersIsLoading = createSelector(
    [(state: RootState) => state.userState.users],
    users => users.isLoading,
);

export default userSlice.reducer;
